import moment from 'moment';
import {WORKMODES} from 'ui/molecules/calendar/utils';
import {dateIsBefore} from 'utils/time';

const ParkingStatus = {
  REQUESTED: 'REQUESTED',
  NOT_REQUESTED: 'NOT_REQUESTED',
  ASSIGNED: 'ASSIGNED',
  NOT_ASSIGNED: 'NOT_ASSIGNED'
};

const deskDateFormat = (date) => moment(date).format('DD, MMM YYYY');

const getBookingDetails = ({
  id,
  date,
  city,
  sector,
  floor,
  code,
  parkingSupported,
  externalParkingSupported,
  parkingNumber,
  plateNumber,
  parkingStatus,
  parkingType,
  duringDrawPeriod,
  datesAndType
}) => {
  const getLocation = () => {
    if (datesAndType && datesAndType.type === WORKMODES.CLIENT) {
      return datesAndType.clientName + ' - ' + datesAndType.clientAddress;
    }
    return `${city ?? ''} - ${sector ?? ''}${floor ? ` - ${floor}` : ''}${
      code ? ` - ${code}` : ''
    }`;
  };
  if (!id) {
    return {
      title: 'Plan not found',
      isPastBooked: true,
      dateFormat: '-',
      location: '-',
      parkingNumber: '-',
      parkingSupported: false
    };
  }
  const isPastBooked = dateIsBefore(date, moment());
  const dateFormat = date ? deskDateFormat(date) : '-';
  const location = getLocation();

  return {
    title: isPastBooked ? 'Past plan' : 'Upcoming plan',
    isPastBooked,
    dateFormat,
    location,
    parkingSupported,
    externalParkingSupported,
    parkingNumber,
    plateNumber,
    parkingStatus,
    parkingType,
    duringDrawPeriod,
    datesAndType
  };
};

const displayParking = (
  parkingNumber,
  plateNumber,
  parkingStatus,
  externalParkingSupported,
  parkingType,
  duringDrawPeriod
) => {
  if (!externalParkingSupported && parkingStatus === ParkingStatus.REQUESTED) {
    return 'Parking requested';
  } else if (
    externalParkingSupported &&
    parkingStatus === ParkingStatus.REQUESTED &&
    (parkingType === 'Internal' || parkingType === 'External')
  ) {
    return `Parking requested (${parkingType})`;
  } else if (
    externalParkingSupported &&
    parkingStatus === ParkingStatus.REQUESTED &&
    parkingType === 'All'
  ) {
    return 'Parking requested (Internal/External)';
  } else if (
    parkingNumber &&
    parkingStatus === ParkingStatus.ASSIGNED &&
    !externalParkingSupported
  ) {
    return `Parking assigned - ${parkingNumber}`;
  } else if (
    parkingNumber &&
    parkingStatus === ParkingStatus.ASSIGNED &&
    externalParkingSupported
  ) {
    return `Parking assigned (${parkingType}) - ${parkingNumber}`;
  } else {
    return duringDrawPeriod ? 'No parking requested' : 'No parking';
  }
};

export {getBookingDetails, deskDateFormat, displayParking, ParkingStatus};
